<p-dialog modal="true" styleClass="atlas-dialog-m" position="top" [closable]="false" [(visible)]="show">
  <ng-template pTemplate="header" *ngIf="!loadingTask">
    <h4>
      {{ task?.TaskId ? ('tasks.edit.edit-header' | translate | titlecase) : ('tasks.edit.new-header' | translate | titlecase) }}
    </h4>
  </ng-template>
  <div class="mct-flex mct-row mct-justify-center mct-items-center">
    <wl-busy [show]="loadingTask"></wl-busy>
  </div>
  <form #crudForm="ngForm">
    <div class="dialog-body-container">
      <div [hidden]="showCrud">
        <p>{{ 'tasks.edit.search-prompt' | translate }}</p>
        <wl-profile-search-and-select (profileSelected)="initWithProfile($event.ProfileId)"></wl-profile-search-and-select>
      </div>
      <div [hidden]="!showCrud">
        <wl-task-edit [task]="task"></wl-task-edit>
      </div>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <button type="button" class="atlas-btn atlas-btn-secondary mr-10" [disabled]="isSaving" (click)="show = false">
      {{ 'common.cancel' | translate | uppercase }}
    </button>
    <button type="button" class="atlas-btn atlas-btn-primary" *ngIf="showCrud" [disabled]="!crudForm.valid" (click)="save()">
      <wl-busy [show]="isSaving"></wl-busy>
      <span [hidden]="isSaving">{{ 'common.save' | translate | uppercase }}</span>
    </button>
    <button type="button" class="atlas-btn atlas-btn-primary" *ngIf="!showCrud" (click)="createUnlinkedTask()">
      {{ 'tasks.edit.create-unlinked-task' | translate | uppercase }}
    </button>
  </ng-template>
</p-dialog>
